import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconChevronDoubleLeft: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconChevronDoubleLeft"><Path d="M10 8L6 12L10 16" stroke="currentColor" strokeLinecap="square"/><Path d="M17 8L13 12L17 16" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconChevronDoubleLeft;
